function TBody(props) {
  const { children } = props;
  return <tbody>{children}</tbody>;
}

export default TBody;
